import { render, staticRenderFns } from "./ClientListFiltersForm.vue?vue&type=template&id=4c9ef07c&scoped=true&"
import script from "./ClientListFiltersForm.vue?vue&type=script&lang=js&"
export * from "./ClientListFiltersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9ef07c",
  null
  
)

export default component.exports